import OBase from './OBase';

import * as Geometry from '../geometry';
// import { GHPlane } from '../../math'

export default class EMaterial extends OBase {
  update () {
    const geomInputTree = this.getObjectInput('geometry', false);
    const matInputTree = this.getFloatInput('materialId');
    const paintInputTree = this.getStringInput('paintId');
    const surfaceAreaInputTree = this.getFloatInput('surfaceArea');

    const output = this.outputs['geometry'].paramObject;

    let dataTrees = [geomInputTree, matInputTree, paintInputTree, surfaceAreaInputTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    let n0 = outDataTrees[0].branches.length;
    let n1 = outDataTrees[1].branches.length;

    if (n0 > 0 && n1 > 0) {
      for (let i = 0; i < outDataTrees[0].branches.length; i++) {
        for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
          const geomInput = outDataTrees[0].branches[i][j];
          const matIdInput = outDataTrees[1].branches[i][j];
          const paintIdInput = outDataTrees[2].branches[i][j];
          const surfaceAreaInput = outDataTrees[3].branches[i][j];

          if (geomInput instanceof THREE.Geometry && typeof (matIdInput) === 'number') {
            geomInput.materialId = matIdInput;
            geomInput.paintId = paintIdInput;
            outTree.add(geomInput, outDataTrees[0].paths[i]);
          }
        }
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EMaterial.js